import { getQueryKeys } from "../../helper";

const namespace = "encryption";

export default {
  ...getQueryKeys(namespace),
};
